import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { setToogleHeader } from "../../../core/redux/action";
import {
  ArrowLeft,
  ChevronDown,
  ChevronUp,
  Info,
  // PlusCircle,
} from "feather-icons-react/build/IconComponents";
import apiHandler from "../../common/api";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
// import { all_routes } from "../../../Router/all_routes";
import config from "../../../config";
import DatePickup from "../../components/DatePickup/DatePickup";
import moment from "moment";
import CommonTextEditor from "../../components/Editor/CommonTextEditor";
import { imgpathgenerator } from "../../../core/Common/imgpathgenerator";
import LoadingSpinner from "../../../InitialPage/Sidebar/LoadingSpinner";

const MasterModule = ({ module = "Superadmin", backto = "/" }) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.user_data);
  const Parms = useParams();
  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);
  const ID = userData?.id || 0;
  const location = useLocation();
  const parts = location.pathname;
  let pathname = parts?.trim()?.split("/");
  console.log(parts, "pathname1");

  // const route = all_routes;
  const data = useSelector((state) => state.toggle_header);
  // const route = all_routes;

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const [formvalue, setformvalue] = useState([
    {
      loginuserid: userData?.id || 0,
      businessId: userData?.businessId || 0,
    },
  ]);

  const [datas, setdata] = useState([]);

  const [optiondata, setoptiondata] = useState({});
  const [imageUrl, setImageUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const Yesterday = moment().subtract(1, "days").toDate();
  // const [filterDate, setFilterDate] = useState(Yesterday);

  const [errors, setErrors] = useState({});

  console.log(imageUrl, "imageUrl");

  console.log(datas, "datas 798");

  // const HandleChange = (e) => {
  //   const { name, value } = e.target;

  //   setformvalue((prevState) => [
  //     {
  //       ...prevState[0],
  //       [name]: value,
  //       loginuserid: ID,
  //       ID: Parms?.id || 0,
  //     },
  //   ]);
  // };

  const HandleChange = (e) => {
    const { name, value } = e.target;

    // simple validation rule: required and cannot be empty
    let newErrors = { ...errors };

    if (!value || value.trim() === "") {
      newErrors[name] = `${name.replace(/([A-Z])/g, " $1")} is required`;
    } else {
      delete newErrors[name];
    }

    setErrors(newErrors);

    setformvalue((prevState) => [
      {
        ...prevState[0],
        [name]: value,
        loginuserid: ID,
        ID: Parms?.id || 0,
      },
    ]);
  };

  const HandleFileChange = (e, label) => {
    const file = e.target.files[0];
    console.log(file, "789654");

    const fileURL = URL.createObjectURL(file);

    setformvalue((prevState) => [
      {
        ...prevState[0],
        [label]: imgpathgenerator(file.name, pathname[1]) || "",
        uniquefileName:
          JSON.stringify([imgpathgenerator(file.name, pathname[1])]) || "[]",
        dirname: `${pathname[1]}`,
        loginuserid: ID,
        ID: Parms?.id || 0,
        files: file,
        Isfile: 1,
        [`${label}Preview`]: fileURL, // Store preview dynamically
      },
      // ...prevState.slice(1),
    ]);
  };

  const HandleSelectChange = (e, label) => {
    console.log(e, "fdgdf");
    setformvalue((prevState) => [
      {
        ...prevState[0],
        [label]: e ? e.value : 0,
        loginuserid: ID,
        ID: Parms?.id || 0,
      },
      //...prevState.slice(1),
    ]);
  };

  const handleDateChange = (e, label) => {
    console.log(e, "selectedDate", label);
    if (e) {
      setformvalue((prevState) => [
        {
          ...prevState[0],
          [label]: e,
          loginuserid: ID,
          ID: Parms?.id || 0,
        },
        //...prevState.slice(1),
      ]);
    }
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    if (e) {
      setformvalue((prevState) => [
        {
          ...prevState[0],
          [name]: checked,
          loginuserid: ID,
          ID: Parms?.id || 0,
        },
        //...prevState.slice(1),
      ]);
    }
  };

  console.log(formvalue, "formvalue");
  // const HandleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  //   const response = await apiHandler({
  //     method: "POST",
  //     route: `${module}/${pathname[1]}Upsert`,
  //     payload: formvalue[0],
  //     headers:
  //       formvalue[0]?.Isfile == 1
  //         ? {
  //             "Content-Type": "multipart/form-data",
  //           }
  //         : { "Content-Type": "application/json" },
  //   });

  //         const ResponseID = response?.ResponseID[0]?.ID
  //     const Message = response?.ResponseID[0]?.Message

  //   if (response.ResponseCode === "SUCCESS") {
  //     console.log(response, "data");
  //     setLoading(false);
  //     if (ResponseID > 0){
  //     MySwal.fire({
  //         title:  Parms?.id > 0 ? `${datas[0]?.routeAlies} Updated!` : `${datas[0]?.routeAlies} Added!`,
  //       text:
  //          Parms?.id > 0
  //           ? `The ${datas[0]?.routeAlies} have been successfully updated.`
  //           : `The ${datas[0]?.routeAlies} has been successfully added.`,
  //       className: "btn btn-success",
  //       confirmButtonText: "OK",
  //       customClass: {
  //         confirmButton: "btn btn-success",
  //       },
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         navigate(-1);
  //       }
  //     });
  //     setImageUrl(
  //       "https://4a09-49-36-88-91.ngrok-free.app/assets/businessType/2025/1/Screenshot%202025-01-29%20122320.png.png"
  //     );
  //   }} else {
  //       MySwal.fire({
  //       icon: "warning",
  //       title: "Duplicate Service Type",
  //       html: `${Message}`,
  //       confirmButtonText: "OK",
  //       confirmButtonColor: "#f8bb86", // optional: yellowish tone
  //       customClass: {
  //         confirmButton: "btn btn-warning", // your existing button style
  //       },
  //     })
  //     setLoading(false);
  //     console.log(response, "data");
  //   }
  // };

  const HandleSubmit = async (e) => {
    e.preventDefault();

    if (!Array.isArray(datas)) {
      MySwal.fire({
        icon: "error",
        title: "Configuration Error",
        text: "Form configuration not found.",
      });
      return;
    }

    let newErrors = {};
    let hasError = false;

    datas.forEach((el) => {
      if (
        (el.inputType === "text" ||
          el.inputType === "textarea" ||
          el.inputType === "select" ||
          el.inputType === "number") &&
        (!formvalue[0][el.label] ||
          formvalue[0][el.label].toString().trim() === "")
      ) {
        newErrors[el.label] = `${el.title} is required`;
        hasError = true;
      }
    });

    setErrors(newErrors);

    if (hasError) {
      MySwal.fire({
        icon: "error",
        title: "Validation Failed",
        text: "Please fill all required fields.",
      });
      return;
    }

    setLoading(true);

    const response = await apiHandler({
      method: "POST",
      route: `${module}/${pathname[1]}Upsert`,
      payload: formvalue[0],
      headers:
        formvalue[0]?.Isfile == 1
          ? { "Content-Type": "multipart/form-data" }
          : { "Content-Type": "application/json" },
    });

   
    // const ResponseID = response?.ResponseID?.[0]?.ID;
    const Message = response?.ResponseID?.[0]?.Message;
console.log(response?.ResponseID, "check this ResponseID");

    if (response?.ResponseCode === "SUCCESS") {
      setLoading(false);
      // navigate(-1);
     
        MySwal.fire({
          title:
            Parms?.id > 0
              ? `${datas[0]?.routeAlies} Updated!`
              : `${datas[0]?.routeAlies} Added!`,
          text:
            Parms?.id > 0
              ? `The ${datas[0]?.routeAlies} has been successfully updated.`
              : `The ${datas[0]?.routeAlies} has been successfully added.`,
          confirmButtonText: "OK",
          customClass: { confirmButton: "btn btn-success" },
        }).then((result) => {
          if (result.isConfirmed) navigate(-1);
        });

        setImageUrl(
          ""
        );
      
    } else {
      setLoading(false);

      MySwal.fire({
        icon: "warning",
        title: "Duplicate Service Type",
        html: `${Message}`,
        confirmButtonText: "OK",
        confirmButtonColor: "#f8bb86",
        customClass: {
          confirmButton: "btn btn-warning",
        },
      });
    }
  };

  const prodcutDataListApi = async () => {
    const response = await apiHandler({
      method: "GET",
      route: `Superadmin/ModulebyRoute?pathname=/${pathname[1]}`,
    });

    if (response.ResponseCode === "SUCCESS") {
      console.log(response, "data");
      setdata(response.ResponseData);

      let Selectfilter = response.ResponseData?.filter(
        (el) => el.inputType == "select"
      );

      for (const el of Selectfilter) {
        const subResponse = await apiHandler({
          method: "GET",
          route: `Superadmin/${el?.options}`,
        });

        if (subResponse.ResponseCode === "SUCCESS") {
          const optionmanage = subResponse.ResponseData?.map((u) => ({
            value: u.ID,
            label: u.Name,
          }));

          if (el?.options) {
            setoptiondata((prevOptionData) => ({
              ...prevOptionData,
              [el.options]: optionmanage,
            }));
          }
        }
      }
    } else {
      console.log(response, "data");
    }

    if (Parms?.id > 0) {
      const response = await apiHandler({
        method: "GET",
        route: `Superadmin/ModuleFindId?Module=${pathname[1]}&ID=${Parms?.id}`,
      });
      if (response.ResponseCode === "SUCCESS") {
        console.log(response, "data");
        setformvalue(response.ResponseData);
      } else {
        console.log(response, "data");
      }
    }
  };

  useEffect(() => {
    prodcutDataListApi();
  }, [parts]);

  console.log(optiondata, "option");

  return (
    <>
      <LoadingSpinner isLoading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>{pathname[1]}</h4>
                <h6>Manage your {pathname[1]}</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={data ? "active" : ""}
                    onClick={(e) => {
                      e.preventDefault();
                      dispatch(setToogleHeader(!data));
                    }}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <div className="page-btn">
                  <button
                    onClick={() => navigate(backto)}
                    className="6 btn btn-primary btn-md btn-wave me-2"
                  >
                    <ArrowLeft className="me-2" />
                    Back to {pathname[1]}
                  </button>
                </div>
              </li>
            </ul>
          </div>

          {/* /add */}
          <form onSubmit={HandleSubmit}>
            <div className="card">
              <div className="card-body add-product pb-0">
                <div
                  className="accordion-card-one accordion"
                  id="accordionExample"
                >
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <div
                        className="accordion-button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                        aria-controls="collapseOne"
                      >
                        <div className="addproduct-icon">
                          <h5>
                            <Info className="add-info" />

                            <span>{pathname[1]} Information</span>
                          </h5>
                          <Link to="#">
                            <ChevronDown className="chevron-down-add" />
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      aria-labelledby="headingOne"
                      data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        {datas?.map((el, index) => {
                          // Handle file input
                          if (el.inputType === "file") {
                            return (
                              <div key={index}>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3 add-product">
                                    {/* Check if a preview is available */}
                                    {formvalue?.[0]?.[`${el.label}Preview`] ? (
                                      <div>
                                        <h3>Preview Image:</h3>
                                        <img
                                          src={
                                            formvalue?.[0]?.[
                                              `${el.label}Preview`
                                            ]
                                          }
                                          alt="Preview Image"
                                          style={{
                                            width: "200px",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            window.open(
                                              formvalue?.[0]?.[
                                                `${el.label}Preview`
                                              ],
                                              "_blank"
                                            )
                                          }
                                          title="Click to open in new tab"
                                        />
                                        <p>
                                          Note: Click Image to open in new tab
                                        </p>
                                      </div>
                                    ) : (
                                      /* Show uploaded image only if preview is not available */
                                      Parms.id > 0 &&
                                      formvalue?.[0]?.[el.label] && (
                                        <div>
                                          <h3>Uploaded Image:</h3>
                                          <img
                                            src={`${config.Imageurl}${
                                              formvalue?.[0]?.[el.label]
                                            }`}
                                            alt="Uploaded Image"
                                            style={{
                                              width: "200px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              window.open(
                                                `${config.Imageurl}${
                                                  formvalue?.[0]?.[el.label]
                                                }`,
                                                "_blank"
                                              )
                                            }
                                            title="Click to open in new tab"
                                          />
                                          <p>
                                            Note: Click Image to open in new tab
                                          </p>
                                        </div>
                                      )
                                    )}

                                    <label className="form-label">
                                      {el?.title}
                                    </label>
                                    <input
                                      type="file"
                                      name={el?.label}
                                      onChange={(e) =>
                                        HandleFileChange(e, el.label)
                                      }
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          }

                          if (el.inputType === "select") {
                            return (
                              <div
                                key={index}
                                className="col-lg-4 col-sm-6 col-12"
                              >
                                <div className="mb-3 add-product">
                                  <label className="form-label">
                                    {el?.title}
                                  </label>
                                  <Select
                                    classNamePrefix="react-select"
                                    name={el?.label}
                                    isClearable={true}
                                    onChange={(e) =>
                                      HandleSelectChange(e, el?.label)
                                    }
                                    placeholder="Choose"
                                    value={optiondata[el?.options]?.find(
                                      (s) =>
                                        s.value === formvalue?.[0]?.[el?.label]
                                    )}
                                    options={optiondata[el?.options]}
                                  />
                                </div>
                              </div>
                            );
                          }

                          if (el.inputType === "date") {
                            const value =
                              formvalue?.[0]?.[el.label] || Yesterday;
                            return (
                              <div
                                key={index}
                                className="col-lg-4 col-sm-6 col-12"
                              >
                                <div className="mb-3 add-product">
                                  <label className="form-label">
                                    {el?.title}
                                  </label>
                                  <DatePickup
                                    filterDate={value}
                                    handleDateChange={(e) =>
                                      handleDateChange(e, el.label)
                                    }
                                  />
                                </div>
                              </div>
                            );
                          }

                          if (el.inputType === "checkbox") {
                            const value = formvalue?.[0]?.[el.label] || false;
                            return (
                              <div
                                key={index}
                                className="col-lg-4 col-sm-6 col-12"
                              >
                                <div className="mb-3 add-product">
                                  <label className="form-label">
                                    {el?.title} :{" "}
                                  </label>
                                  <input
                                    type={el?.inputType}
                                    name={el?.label}
                                    checked={value}
                                    onChange={handleCheckboxChange}
                                    style={{ marginLeft: "4px" }}
                                    className="ml-1 custome-boder form-check-input"
                                  />
                                </div>
                              </div>
                            );
                          }

                          if (el.inputType === "textarea") {
                            const value = formvalue?.[0]?.[el.label] || "";
                            return (
                              <div key={index}>
                                <div className="col-lg-4 col-sm-6 col-12">
                                  <div className="mb-3 add-product">
                                    <label className="form-label">
                                      {el?.title}
                                    </label>
                                    <textarea
                                      type={el?.inputType}
                                      name={el?.label}
                                      value={value}
                                      onChange={(e) => HandleChange(e)}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          }

                          if (el.inputType === "textEditor") {
                            const value = formvalue?.[0]?.[el.label] || "";
                            return (
                              <div key={index}>
                                <div className="col-lg-8 col-sm-6 col-12">
                                  <div className="mb-3 add-product">
                                    <label className="form-label">
                                      {el?.title}
                                    </label>
                                    <CommonTextEditor
                                      onChange={HandleChange}
                                      value={value}
                                      name={el?.label}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          }
                          // Handle other input types like text
                          const value = formvalue?.[0]?.[el.label] ?? "";

                          return (
                            <div key={index} className="col-lg-4 col-sm-6 col-12">
                              <div className="mb-3 add-product">
                                <label className="form-label">{el?.title}</label>

                                <input
                                  type={el?.inputType}
                                  name={el?.label}
                                  value={value}
                                  onChange={HandleChange}
                                  className={`form-control ${errors?.[el.label] ? "is-invalid" : ""}`}
                                />

                                {errors?.[el.label] && (
                                  <div className="invalid-feedback" style={{ display: "block" }}>
                                    {errors[el.label]}
                                  </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-12">
              <div className="btn-addproduct mb-4">
                {/* <button type="button" className="btn btn-cancel me-2">
                Cancel
              </button> */}
                <button
                  onClick={() => navigate(backto)}
                  className="btn btn-outline-primary btn-md me-2"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="5 btn btn-primary btn-md btn-wave me-2"
                >
                  Save {pathname[1]}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default MasterModule;
